import { styled } from '@mui/material/styles'
import { Checkbox as CheckboxMui } from '@mui/material'
import PropTypes from 'prop-types'

const PREFIX = 'Checkbox'

const classes = {
  root: `${PREFIX}-root`,
  disabled: `${PREFIX}-disabled`,
  checked: `${PREFIX}-checked`,
  indeterminate: `${PREFIX}-indeterminate`,
}

const StyledCheckboxMui = styled(CheckboxMui)(() => {
  return {
    [`& .${classes.root}`]: {
      width: '16px',
      height: '16px',
      fill: '#666666',
      '&$disabled': {
        color: '#888888',
      },
      '&$checked': {
        fill: '#366CD9',
      },
      '&$indeterminate': {
        fill: '#366CD9',
      },
    },
    [`& .${classes.disabled}`]: {},
    [`& .${classes.checked}`]: {},
    [`& .${classes.indeterminate}`]: {},
  }
})

const Checkbox = props => {
  return (
    <StyledCheckboxMui
      color="primary"
      classes={{
        root: classes.root,
        disabled: classes.disabled,
        checked: classes.checked,
        indeterminate: classes.indeterminate,
      }}
      {...props}
    />
  )
}

Checkbox.propTypes = {
  classes: PropTypes.object,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default Checkbox
